import Vue from "vue";

const queryString = window.location.search;
const params = new URLSearchParams(queryString);
const m = params.get("m");

const domain = document.domain;
const port = window.location.port;

const THEMES = {
  blue: {
    path: "blue",
    color1: "#81c7e8",
    color2: "#679dd4",
    color3: "#055d9b",
  },
  leejia: {
    path: "leejia",
    color1: "#D4B5D2",
    color2: "#7F4568",
    color3: "#423345",
  },
  hw: {
    path: "hw",
    color1: "#DCC4D8",
    color2: "#DCC4D8",
    color3: "#DCC4D8",
    color4: "#DCC4D8",
  },
  greenblue: {
    path: "greenblue",
    color1: "#a9d297",
    color2: "#00c7aa",
    color3: "#009aaa",
    color4: "rgb(123 214 216)",
  },
  redblack: {
    path: "redblack",
    color1: "#ffb1b1",
    color2: "#00c7aa",
    color3: "#009aaa",
    color4: "#ffb1b1",
  },
  default: {
    path: "",
    color1: "#a9d297",
    color2: "#00c7aa",
    color3: "#009aaa",
    color4: "#a9d297",
  },
};

const blueDomains = new Set([
  process.env.VUE_APP_TYH,
  "43.138.153.196",
  "47.243.93.168",
  "47.239.136.97",
  "store.rzxl923.com",
  "ht.hdsaj.com",
]);

const leejiaDomains = new Set([
  process.env.VUE_APP_LEEJIA,
  "store.niks882.com",
]);

const hwDomains = new Set(["47.242.225.81", "47.83.129.213"]);

const greenblueDomains = new Set([
  process.env.VUE_APP_PPP,
  "119.91.195.29",
  process.env.VUE_APP_CROWN,
  process.env.VUE_APP_ZHAOFU,
  "store.kxzi342.com",
  "119.28.31.200",
  "129.226.121.148",
  "store.rxjh382.com",
  "43.139.102.188",
  "store.hspf115.com",
  "store.xoazww.com",
  "store.soax0z.com",
  "119.91.48.139",
  "101.33.250.39",
  "42.193.130.202",
  "47.242.177.16",
  "150.109.117.219",
  "47.76.29.193",
  "47.238.137.188",
  "47.238.111.137",
  "47.83.129.213",
  "47.83.168.207",
  "47.242.225.81",
  "47.239.153.189",
  "47.239.98.118",
  "47.242.41.206",
  "8.210.76.250",
  "119.28.73.52",
  "47.83.153.10",
  "b.hdsaj.com",
]);

const redblackDomains = new Set([
  "store.olzde8213.com",
  "42.194.148.159",
  "47.239.88.174",
  "47.239.169.10",
]);

const hwFallbackDomains = new Set([
  "running.etmart2.test",
  "43.155.13.226",
  "43.129.64.215",
  "150.109.61.55",
  "101.32.177.157",
  "store.lxiadc12.com",
]);

function isHwMode() {
  return (m && m === "hw") || localStorage.getItem("mI") === "hw";
}

function isBlueDomain() {
  return blueDomains.has(domain);
}

function isLeejiaDomain() {
  return leejiaDomains.has(domain);
}

function isHwDomain() {
  return hwDomains.has(domain) && isHwMode();
}

function isGreenblueDomain() {
  return (
    greenblueDomains.has(domain) || port == 82 || domain.includes("kxzi342")
  );
}

function isRedblackDomain() {
  return redblackDomains.has(domain);
}

function isHwFallbackDomain() {
  return hwFallbackDomains.has(domain);
}

Vue.prototype.$returnColor = function returnColor() {
  if (isBlueDomain()) {
    return THEMES.blue;
  }

  if (isLeejiaDomain()) {
    return THEMES.leejia;
  }

  if (isHwDomain()) {
    return THEMES.hw;
  }

  if (isGreenblueDomain()) {
    return THEMES.greenblue;
  }

  if (isRedblackDomain()) {
    return THEMES.redblack;
  }

  if (isHwFallbackDomain()) {
    return THEMES.hw;
  }

  return THEMES.default;
};
